import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForYouSection() {
  return <Section className="bg-white" data-id="element-30">
      <div className="grid md:grid-cols-2 gap-8" data-id="element-31">
        {/* Is For You */}
        <div className="bg-[#FAF8F5] p-8 rounded-2xl border-t-4 border-[#D4735E]" data-id="element-32">
          <h3 className="text-2xl font-serif font-bold text-[#2D2D2D] mb-6 flex items-center gap-3" data-id="element-33">
            <CheckCircle2 className="text-[#D4735E]" data-id="element-34" />
            ES PARA TI SI…
          </h3>
          <ul className="space-y-4" data-id="element-35">
            {['Siempre atraes hombres emocionalmente no disponibles', 'Te ghostean', 'Nunca te eligen', 'Estás cansada de repetir el patrón'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-[#666666]" data-id="element-36">
                <span className="mt-2 w-1.5 h-1.5 bg-[#D4735E] rounded-full flex-shrink-0" data-id="element-37" />
                {item}
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-[#2D2D2D] p-8 rounded-2xl border-t-4 border-gray-500 text-white" data-id="element-38">
          <h3 className="text-2xl font-serif font-bold mb-6 flex items-center gap-3" data-id="element-39">
            <XCircle className="text-gray-400" data-id="element-40" />
            NO ES PARA TI SI…
          </h3>
          <ul className="space-y-4" data-id="element-41">
            {['Buscas magia', 'Quieres que los hombres cambien', 'No quieres cambiar tu conducta'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-300" data-id="element-42">
                <span className="mt-2 w-1.5 h-1.5 bg-gray-500 rounded-full flex-shrink-0" data-id="element-43" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}